export default {"src":"/_next/static/media/heartofpalm.34cda49b.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};